
import {
    SET_ROUTES,
    SET_ROLE,
    SET_TOKEN,
    SET_USER_INFO,
    SET_IS_MOBILE, SET_THEME,
    SET_LAYOUT,
    SET_MULTIPAGE,
    SET_FIXED_HEADER,
    SET_FIXED_SIDEBAR,
    SET_REVIEW_OPERATION,
    SET_SYSTEM_NAME,
    SET_COPYRIGHT,
    SET_LICENSE_NUMBER,
    SET_PAYMENT_EARNEST_MONEY_MANAGEMENT_TYPE,
    SET_IS_INIT,
    SET_LOGIN_URL,
    SET_REGISTER_URL,
    SET_SUPERVISION_URL,
    SET_REDIRECT_MODE,
    SET_MARGIN_AMOUNT_STATISTICS,
    SET_TECHNICAL_SUPPORT,
    SHOW_COMPLAINTS,
    SHOW_CREDIT_PUBLICITY,
    SHOW_ENTERPRISE_CENTER,
    SHOW_HANDLING_GUIDE,
    SHOW_INDEX,
    SHOW_ORG_PUBLICITY,
    SHOW_POLICIES_REGULATIONS,
    SHOW_SUPERVISION_CENTER,
    SHOW_POLICY_VERIFICATION,

    SET_DOMAIN_NAME_TITLE,
    SET_VERSION
  
} from './mutation-types'
import {setDocumentTitle} from '@/utils/dom'

export default {
    [SET_USER_INFO](state, userInfo) {
        state.userInfo = userInfo
    },
    [SET_TOKEN](state, token) {
        state.token = token
    },
    [SET_ROUTES](state, routes) {
        state.addRouters = routes
        state.routes = routes
    },
    [SET_ROLE](state, role) {
        state.role = role
    },
    [SET_IS_MOBILE](state, isMobile) {
        state.isMobile = isMobile
    },
    [SET_THEME](state, theme) {
        state.theme = theme
    },
    [SET_LAYOUT](state, layout) {
        state.layout = layout
    },
    [SET_MULTIPAGE](state, multipage) {
        state.multipage = multipage
    },
    [SET_FIXED_HEADER](state, fixedHeader) {
        state.fixedHeader = fixedHeader
    },
    [SET_FIXED_SIDEBAR](state, fixedSidebar) {
        state.fixedSidebar = fixedSidebar
    },
    [SET_REVIEW_OPERATION](state, info) {
        state.reviewOperation = info
    },
    [SET_SYSTEM_NAME](state, systemName) {
        state.systemName = systemName
        setDocumentTitle(systemName)
    },
    [SET_COPYRIGHT](state,copyright){
        state.copyright = copyright
    },
    [SET_LICENSE_NUMBER](state,licenseNumber){
        state.licenseNumber = licenseNumber
    },
    [SET_PAYMENT_EARNEST_MONEY_MANAGEMENT_TYPE](state, paymentEarnestMoneyManagementType) {
        state.paymentEarnestMoneyManagementType = paymentEarnestMoneyManagementType
    },
    [SET_IS_INIT](state, isInit) {
        state.isInit = isInit
    },
    [SET_LOGIN_URL](state, loginUrl) {
        state.loginUrl = loginUrl
    },
    [SET_REGISTER_URL](state, registerUrl) {
        state.registerUrl = registerUrl
    },
    [SET_SUPERVISION_URL](state, supervisionUrl) {
        state.supervisionUrl = supervisionUrl
    },
    [SET_MARGIN_AMOUNT_STATISTICS](state, marginAmountStatistics) {
        state.marginAmountStatistics = marginAmountStatistics
    },
    [SET_TECHNICAL_SUPPORT](state, technicalSupport) {
        state.technicalSupport = technicalSupport
    },

    [SHOW_COMPLAINTS](state, showComplaints) {
        state.showComplaints = showComplaints
    },
    [SHOW_CREDIT_PUBLICITY](state, showCreditPublicity) {
        state.showCreditPublicity = showCreditPublicity
    },
    [SHOW_ENTERPRISE_CENTER](state, showEnterpriseCenter) {
        state.showEnterpriseCenter = showEnterpriseCenter
    },
    [SHOW_HANDLING_GUIDE](state, showHandlingGuide) {
        state.showHandlingGuide = showHandlingGuide
    },
    [SHOW_INDEX](state, showIndex) {
        state.showIndex = showIndex
    },
    [SHOW_ORG_PUBLICITY](state, showOrgPublicity) {
        state.showOrgPublicity = showOrgPublicity
    },
    [SHOW_POLICIES_REGULATIONS](state, showPoliciesRegulations) {
        state.showPoliciesRegulations = showPoliciesRegulations
    },
    [SHOW_SUPERVISION_CENTER](state, showSupervisionCenter) {
        state.showSupervisionCenter = showSupervisionCenter
    },
    [SHOW_POLICY_VERIFICATION](state, showPolicyVerification) {
        state.showPolicyVerification = showPolicyVerification
    },

    [SET_DOMAIN_NAME_TITLE](state, domainNameTitle) {
        state.domainNameTitle = domainNameTitle
    },

    [SET_VERSION](state, version) {
        state.version = version
    }
    
    
    
}